webpackJsonp([114276838955818,60335399758886],{

/***/ 106:
/***/ (function(module, exports) {

	module.exports = {"layoutContext":{}}

/***/ }),

/***/ 169:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _index = __webpack_require__(177);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _layoutIndex = __webpack_require__(106);
	
	var _layoutIndex2 = _interopRequireDefault(_layoutIndex);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(_index2.default, _extends({}, props, _layoutIndex2.default));
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 173:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  width: 100%;\n  padding: 16px 0 32px;\n  margin-top: 40px;\n  border-top: 1px solid #e7eefd;\n  font-size: 14px;\n  color: ', ';\n\n  a {\n    margin: 0 8px;\n    color: ', ';\n    text-decoration: none;\n    border-bottom: 0;\n  }\n'], ['\n  width: 100%;\n  padding: 16px 0 32px;\n  margin-top: 40px;\n  border-top: 1px solid #e7eefd;\n  font-size: 14px;\n  color: ', ';\n\n  a {\n    margin: 0 8px;\n    color: ', ';\n    text-decoration: none;\n    border-bottom: 0;\n  }\n']);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gridStyled = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var CURRENT_YEAR = new Date().getFullYear();
	
	var StyledFooter = _gridStyled.Flex.extend(_templateObject, function (props) {
	  return props.theme.colors.text;
	}, function (props) {
	  return props.theme.colors.text;
	});
	
	var Footer = function Footer() {
	  return _react2.default.createElement(
	    StyledFooter,
	    { is: 'footer' },
	    _react2.default.createElement(
	      'span',
	      { itemScope: '', itemType: 'http://schema.org/Organization' },
	      _react2.default.createElement('link', { itemProp: 'url', href: 'http://oluwole.co' }),
	      '\xA9 ',
	      CURRENT_YEAR,
	      ' -',
	      _react2.default.createElement(
	        'a',
	        {
	          target: '_blank',
	          rel: 'noopener noreferrer me',
	          href: 'https://twitter.com/oluwoleco',
	          itemProp: 'sameAs'
	        },
	        'Twitter'
	      ),
	      _react2.default.createElement(
	        'a',
	        {
	          target: '_blank',
	          rel: 'noopener noreferrer me',
	          href: 'http://github.com/oluwoleco',
	          itemProp: 'sameAs'
	        },
	        'GitHub'
	      ),
	      _react2.default.createElement(
	        'a',
	        {
	          target: '_blank',
	          rel: 'noopener noreferrer',
	          href: 'http://medium.com/@oluwoleco'
	        },
	        'Medium'
	      )
	    ),
	    '   '
	  );
	};
	
	exports.default = Footer;
	module.exports = exports['default'];

/***/ }),

/***/ 174:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  display: block;\n  color: ', ';\n  text-decoration: none;\n  border-bottom: 0;\n  font-weight: 500;\n  font-size: 14px;\n'], ['\n  display: block;\n  color: ', ';\n  text-decoration: none;\n  border-bottom: 0;\n  font-weight: 500;\n  font-size: 14px;\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n  width: 100%;\n  padding: 32px 0 24px;\n  background-color: ', ';\n  position: sticky;\n  top: 0;\n  z-index: 10;\n  border-bottom: 1px solid #e7eefd;\n'], ['\n  width: 100%;\n  padding: 32px 0 24px;\n  background-color: ', ';\n  position: sticky;\n  top: 0;\n  z-index: 10;\n  border-bottom: 1px solid #e7eefd;\n']),
	    _templateObject3 = _taggedTemplateLiteralLoose(['\n  display: flex;\n  align-items: center;\n  flex-shrink: 0;\n\n  ul {\n    list-style: none;\n    margin: 0;\n    padding: 0;\n\n    li {\n      display: inline-block;\n      padding: 0 8px;\n    }\n  }\n\n  a {\n    color: ', ';\n    border-bottom: 0;\n\n    &:hover {\n      color: ', ';\n    }\n  }\n'], ['\n  display: flex;\n  align-items: center;\n  flex-shrink: 0;\n\n  ul {\n    list-style: none;\n    margin: 0;\n    padding: 0;\n\n    li {\n      display: inline-block;\n      padding: 0 8px;\n    }\n  }\n\n  a {\n    color: ', ';\n    border-bottom: 0;\n\n    &:hover {\n      color: ', ';\n    }\n  }\n']);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(10);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _gatsbyLink = __webpack_require__(102);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _gridStyled = __webpack_require__(9);
	
	var _typography = __webpack_require__(13);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Logo = (0, _styledComponents2.default)('a')(_templateObject, function (props) {
	  return props.theme.colors.text;
	});
	
	var StyledNav = _gridStyled.Flex.extend(_templateObject2, function (props) {
	  return props.theme.colors.background;
	});
	
	var Nav = _gridStyled.Box.extend(_templateObject3, function (props) {
	  return props.theme.colors.text;
	}, function (props) {
	  return props.theme.colors.textHover;
	});
	
	exports.default = function () {
	  return _react2.default.createElement(
	    StyledNav,
	    { is: 'header', justify: 'space-between' },
	    _react2.default.createElement(
	      Logo,
	      { href: '/' },
	      'Oluwole Oyekanmi'
	    ),
	    _react2.default.createElement(
	      Nav,
	      { is: 'nav' },
	      _react2.default.createElement(
	        'ul',
	        null,
	        _react2.default.createElement(
	          'li',
	          null,
	          _react2.default.createElement(
	            _typography.Text,
	            { fontSize: [1, 2], style: { lineHeight: '1em' } },
	            _react2.default.createElement(
	              _gatsbyLink2.default,
	              { to: '/about/' },
	              'About Me'
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'li',
	          null,
	          _react2.default.createElement(
	            _typography.Text,
	            { fontSize: [1, 2], style: { lineHeight: '1em' } },
	            _react2.default.createElement(
	              'a',
	              {
	                href: 'https://twitter.com/messages/compose?recipient_id=50334921',
	                target: '_blank',
	                rel: 'noopener noreferrer'
	              },
	              'Contact Me'
	            )
	          )
	        )
	      )
	    )
	  );
	};
	
	module.exports = exports['default'];

/***/ }),

/***/ 176:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  @font-face {\n    font-family: \'Graphik Web\';\n    src: url(', ') format(\'woff2\'),\n      url(', ') format(\'woff\');\n    font-weight: 400;\n  }\n\n  @font-face {\n    font-family: \'Graphik Web\';\n    src: url(', ') format(\'woff2\'),\n      url(', ') format(\'woff\');\n    font-weight: 500;\n  }\n\n  ::selection {\n    background-color: #00f;\n    color: #fff;\n  }\n\n  * {\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n    box-sizing: border-box;\n  }\n\n  body {\n    font-family: \'Graphik Web\', -apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif;\n    margin: 0;\n    padding: 0;\n    min-height: 100vh;\n  }\n\n  a {\n    text-decoration: none;\n\n    &:hover {\n      color: ', ';\n    }\n  }\n\n  p {\n    margin: 0;\n    padding: 0;\n  }\n\n  .content {\n    a {\n      border-bottom: 1px solid ', ';\n\n      &:visited {\n        color: inherit;\n      }\n\n      &:active {\n        background-color: ', ';\n        color: #fff;\n      }\n    }\n  }\n'], ['\n  @font-face {\n    font-family: \'Graphik Web\';\n    src: url(', ') format(\'woff2\'),\n      url(', ') format(\'woff\');\n    font-weight: 400;\n  }\n\n  @font-face {\n    font-family: \'Graphik Web\';\n    src: url(', ') format(\'woff2\'),\n      url(', ') format(\'woff\');\n    font-weight: 500;\n  }\n\n  ::selection {\n    background-color: #00f;\n    color: #fff;\n  }\n\n  * {\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n    box-sizing: border-box;\n  }\n\n  body {\n    font-family: \'Graphik Web\', -apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif;\n    margin: 0;\n    padding: 0;\n    min-height: 100vh;\n  }\n\n  a {\n    text-decoration: none;\n\n    &:hover {\n      color: ', ';\n    }\n  }\n\n  p {\n    margin: 0;\n    padding: 0;\n  }\n\n  .content {\n    a {\n      border-bottom: 1px solid ', ';\n\n      &:visited {\n        color: inherit;\n      }\n\n      &:active {\n        background-color: ', ';\n        color: #fff;\n      }\n    }\n  }\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n  background-color: ', ';\n  min-height: 100vh;\n'], ['\n  background-color: ', ';\n  min-height: 100vh;\n']);
	
	var _styledComponents = __webpack_require__(10);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _graphikRegular = __webpack_require__(273);
	
	var _graphikRegular2 = _interopRequireDefault(_graphikRegular);
	
	var _graphikRegular3 = __webpack_require__(274);
	
	var _graphikRegular4 = _interopRequireDefault(_graphikRegular3);
	
	var _graphikMedium = __webpack_require__(271);
	
	var _graphikMedium2 = _interopRequireDefault(_graphikMedium);
	
	var _graphikMedium3 = __webpack_require__(272);
	
	var _graphikMedium4 = _interopRequireDefault(_graphikMedium3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	// eslint-disable-next-line no-unused-expressions
	(0, _styledComponents.injectGlobal)(_templateObject, _graphikRegular4.default, _graphikRegular2.default, _graphikMedium4.default, _graphikMedium2.default, function (props) {
	  return props.theme.colors.primary;
	}, function (props) {
	  return props.theme.colors.primary;
	}, function (props) {
	  return props.theme.colors.primary;
	});
	
	exports.default = _styledComponents2.default.div(_templateObject2, function (props) {
	  return props.theme.colors.background;
	});
	module.exports = exports['default'];

/***/ }),

/***/ 177:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  width: 100%;\n  max-width: 740px;\n  margin: 0 auto;\n  padding: 0 16px;\n'], ['\n  width: 100%;\n  max-width: 740px;\n  margin: 0 auto;\n  padding: 0 16px;\n']);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(10);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _footer = __webpack_require__(173);
	
	var _footer2 = _interopRequireDefault(_footer);
	
	var _header = __webpack_require__(174);
	
	var _header2 = _interopRequireDefault(_header);
	
	var _page = __webpack_require__(176);
	
	var _page2 = _interopRequireDefault(_page);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var theme = {
	  fontWeight: [300, 400, 500, 600],
	  fontSizes: [12, 14, 16, 18, 20, 24, 32, 48, 64, 72],
	  colors: {
	    background: '#fcfdff',
	    heading: '#494E72',
	    text: '#4E6087',
	    textHover: '#3336c7',
	    toggleBackground: '#3336c7',
	    toggleButton: '#fcfdff',
	    border: '#e6e9ef',
	    link: '#3336c7',
	    primary: '#00f'
	  }
	};
	
	var Inner = _styledComponents2.default.div(_templateObject);
	
	exports.default = function (props) {
	  return _react2.default.createElement(
	    _styledComponents.ThemeProvider,
	    { theme: theme },
	    _react2.default.createElement(
	      _page2.default,
	      null,
	      _react2.default.createElement(
	        Inner,
	        null,
	        _react2.default.createElement(_header2.default, null),
	        props.children(),
	        _react2.default.createElement(_footer2.default, null)
	      )
	    )
	  );
	};
	
	module.exports = exports['default'];

/***/ }),

/***/ 271:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/graphik-medium.b3bed846.woff";

/***/ }),

/***/ 272:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/graphik-medium.592620fe.woff2";

/***/ }),

/***/ 273:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/graphik-regular.7bd4c44d.woff";

/***/ }),

/***/ 274:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/graphik-regular.45aa9506.woff2";

/***/ })

});


// WEBPACK FOOTER //
// component---src-layouts-index-js-6364420b507e2602b622.js